// extracted by mini-css-extract-plugin
module.exports = {"container":"add-card-modal_container__2dfcm","title":"add-card-modal_title__2bbQp","close":"add-card-modal_close__1T6Yp"};